var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('el-container',{staticClass:"container"},[_c('el-aside',{attrs:{"width":"200px"}},[_c('sidebar')],1),_c('el-main',{staticClass:"main"},[_c('div',{staticClass:"content"},[_c('router-view',{key:new Date().getTime()})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }